// NewTeamInvoiceDrawer's reads and writes (finance-real, the user 2026-10-22: "should be able to select the jobs here
// already"): for the person picked, their draft if they have one, their owed claims and the jobs to claim on; what the
// ticked claims add up to; a claim on another job, made before the draft (the job drawer's rule); and the draft itself.
import type { UseMutationResult, UseQueryResult } from "@tanstack/react-query";
import { useAddClaim } from "../../hooks/useJobClaims";
import { useCreateTeamInvoice, useTeamClaimsTotal, useTeamInvoiceCandidates } from "../../hooks/useTeamInvoices";
import type { JobClaim, JobClaimInput, TeamInvoice, TeamInvoiceCandidates, TeamInvoiceCreateInput } from "../../types";

export interface NewTeamInvoiceDrawerModel {
  candidates: UseQueryResult<TeamInvoiceCandidates>;
  total: UseQueryResult<number>;
  claim: UseMutationResult<JobClaim, Error, { jobId: string; input: JobClaimInput }>;
  create: UseMutationResult<TeamInvoice, Error, TeamInvoiceCreateInput>;
}

export function useNewTeamInvoiceDrawer(personId: string | null, ticked: string[]): NewTeamInvoiceDrawerModel {
  return {
    candidates: useTeamInvoiceCandidates(personId),
    total: useTeamClaimsTotal(personId, ticked),
    claim: useAddClaim(),
    create: useCreateTeamInvoice(),
  };
}
